import React, { Component } from 'react';
import { BaseButton } from '@stelecom/ui-react/components/buttons/baseButton';
import Input from '@stelecom/ui-react/components/input';

class EnterContractNumber extends Component {
    state = {
        clientContact: '',
        buttonDisabled: true
    }

    onEnterPress = (event) => {
        const { clientContact, buttonDisabled } = this.state;
        if (event.which === 13 && !buttonDisabled) {
            this.props.next(clientContact);
        }
    }

    onChange = (newValue) => {
        this.setState({
            clientContact: newValue,
            buttonDisabled: newValue.length < 5
        });
    }

    render() {
        const { clientContact, buttonDisabled } = this.state;
        const { next } = this.props;
        return (
            <React.Fragment>
                <Input key='contract' type='agreement' value={clientContact} onChange={this.onChange} onKeyPress={this.onEnterPress} errorMargin={true}></Input>
                <BaseButton
                    block
                    onClick={() => next(clientContact)}
                    disabled={buttonDisabled}
                >
                    {'Далее'}
                </BaseButton>
            </React.Fragment>
        );
    }
}

export default EnterContractNumber;
